export class User {
    id:number = 0;
    name:string = '';
    last_name:string = '';
    email:string = '';
    password:string = '';
    password_confirmation:string = '';
    unity_id:number = null;
    warehouse_id:number = null;
    supplier_id:number = null;
    edit:boolean = true;
    user_type: string = '';
}
